<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { HeaderBanner } from './HeaderBannerBaseCard.vue'
import HeaderBannerBaseCard from './HeaderBannerBaseCard.vue'

/**
 * HeaderBannerClippedCard component displays a banner for the "clipped" variant.
 *
 * Constraints:
 * - fixed (var(--header-banner-static-section-width, 179px)), absolutely positioned right section
 * - left side expanding width
 * - if subtext is present, the font size will be reduced
 */
export default defineComponent({
  components: {
    HeaderBannerBaseCard,
  },
  props: {
    banner: {
      type: Object as PropType<HeaderBanner>,
      required: true,
      validator(value: HeaderBanner) {
        if (value.variant !== 'clipped') {
          console.warn(
            `Incorrect variant "${value.variant}" in HeaderBannerClippedCard`,
            this
          )
          return false
        }

        return true
      },
    },
  },
})
</script>

<template>
  <HeaderBannerBaseCard
    :banner="banner"
    class="header-banner--clipped @container/clipped"
  />
</template>

<style lang="scss">
.header-banner.header-banner--clipped {
  .header-banner__content {
    @apply p-4;
  }

  .header-banner__text {
    @apply text-xl @[20em]/clipped:text-2xl leading-none !important;
  }

  .header-banner__subtext {
    @apply text-xs !important;
  }

  .header-banner__trustpilot {
    @apply hidden @[22em]/clipped:block;
  }

  .header-banner__image {
    @apply absolute right-0 top-0 w-[var(--header-banner-static-section-width)];

    img {
      @apply h-full object-cover;
    }
  }
}
</style>
